import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from "react-router-dom";

import { socketUseEffect } from "../../socket";
import PageTitle from "../core/page-title";

import SideBar from "../core/dashboards/sidebar";
import MainDashboardContent from "../core/dashboards/section";

import Dashboard from "./sub-pages/certificates/dashboard";
import { useAuth } from "../../AuthContext";
import { IconEdit, IconLayoutDashboard, IconTrash } from "@tabler/icons-react";
import Certificates from "./certificates";

// ---- i18n ----
const dict = {
    en: {
        loading: "Loading...",
        titlePrefix: "Certificates",
        subTitle: "Details",
        linkList: "Certificates Tests",
        tabs: {
            dashboard: "Dashboard",
            edit: "Edit",
            delete: "Remove",
        },
        sort: {
            status: "Status",
            name: "Name",
            created: "Created Date",
        },
    },
    ru: {
        loading: "Загрузка...",
        titlePrefix: "Сертификаты",
        subTitle: "Детали",
        linkList: "Тесты сертификатов",
        tabs: {
            dashboard: "Дашборд",
            edit: "Редактировать",
            delete: "Удалить",
        },
        sort: {
            status: "Статус",
            name: "Имя",
            created: "Дата создания",
        },
    },
    ua: {
        loading: "Завантаження...",
        titlePrefix: "Сертифікати",
        subTitle: "Деталі",
        linkList: "Тести сертифікатів",
        tabs: {
            dashboard: "Панель",
            edit: "Редагувати",
            delete: "Видалити",
        },
        sort: {
            status: "Статус",
            name: "Назва",
            created: "Дата створення",
        },
    },
};

const getInitialLang = () => (localStorage.getItem("lang") || "en").toLowerCase();

const CertificatesDashboard = ({ lang: langProp, ...props }) => {
    const lang = langProp || getInitialLang();
    const t = useMemo(() => dict[lang] || dict.en, [lang]);

    const [details, setDetails] = useState({ name: t.loading, domain_name: t.loading });
    const [logs, setLogs] = useState([]);
    const { id, page } = useParams();

    const [refresh, setRefresh] = useState(true);

    const { user } = useAuth();
    const listeners = [
        { name: "certificates", fn: "get", args: { user_id: user.user_id, id: id }, saveDataFN: setDetails, row: "0" },
        { name: "certificates", fn: "logs", args: { user_id: user.user_id, id: id }, saveDataFN: (res) => setLogs(res.data || []) },
    ];
    useEffect(() => socketUseEffect(listeners, user), [id, page, refresh, user]);

    const tabs = useMemo(() => ([
        { label: t.tabs.dashboard, page: "dashboard", link: "/certificates/:id/dashboard", controller: Dashboard, args: { details, logs } },
        { label: t.tabs.edit,      page: "edit",      link: "/certificates/:id/edit",      controller: Certificates, args: { edit: 1, id, details, refresh, setRefresh } },
        { label: t.tabs.delete,    page: "delete",    link: "/certificates/:id/delete",    controller: Certificates, args: { delete: 1, id, details, refresh, setRefresh } },
    ]), [t, details, logs, id, refresh, setRefresh]);

    const icons = {
        dashboard: <IconLayoutDashboard size={20} />,
        edit: <IconEdit size={20} />,
        delete: <IconTrash size={20} />,
    };

    const sort = [
        { label: t.sort.status,  column: "status" },
        { label: t.sort.name,    column: "name" },
        { label: t.sort.created, column: "created_date" },
    ];

    return (
        <>
            <PageTitle
                title={
                    <>
                        {t.titlePrefix}: {details.domain_name === t.loading ? <span className="loading-text">{t.loading}</span> : details.domain_name}
                    </>
                }
                homeUrl={"/dashboard"}
                subTitle={t.subTitle}
                links={[{ name: t.linkList, link: "/certificates" }]}
                menuItems={tabs}
                menuIcons={icons}
                curPage={page}
                curID={id}
            />
            <div className={"card overflow-hidden invoice-application"}>
                <div className="d-flex">
                    <div className="w-25 d-none d-lg-block border-end user-chat-box">
                        <div className="app-invoice">
                            <ul className="overflow-auto invoice-users simplebar-scrollable-y" data-simplebar="init">
                                <div className="simplebar-wrapper" style={{ margin: "0px" }}>
                                    <div className="simplebar-height-auto-observer-wrapper">
                                        <div className="simplebar-height-auto-observer"></div>
                                    </div>
                                    <div className="simplebar-mask">
                                        <div className="simplebar-offset" style={{ right: "0px", bottom: "0px" }}>
                                            <div
                                                className="simplebar-content-wrapper"
                                                tabIndex="0"
                                                role="region"
                                                aria-label="scrollable content"
                                                style={{ height: "100%", overflow: "hidden scroll" }}
                                            >
                                                <div className="simplebar-content" style={{ padding: "0px" }}>
                                                    <SideBar
                                                        id={id}
                                                        sort={sort}
                                                        object={"certificates"}
                                                        path={"certificates"}
                                                        controller={Certificates}
                                                        refresh={refresh}
                                                        setRefresh={setRefresh}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="simplebar-placeholder" style={{ width: "280px", height: "459px" }}></div>
                                </div>
                                <div className="simplebar-track simplebar-horizontal" style={{ visibility: "hidden" }}>
                                    <div className="simplebar-scrollbar" style={{ width: "0px", display: "none" }}></div>
                                </div>
                                <div className="simplebar-track simplebar-vertical" style={{ visibility: "visible" }}>
                                    <div
                                        className="simplebar-scrollbar"
                                        style={{ height: "25px", display: "block", transform: "translate3d(0px, 0px, 0px)" }}
                                    ></div>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <div className="w-75 w-xs-100 chat-container">
                        <div className="invoice-inner-part h-100">
                            <div className="invoiceing-box">
                                <div id="custom-invoice">
                                    <MainDashboardContent tabs={tabs} page={page} id={id} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CertificatesDashboard;
